<template>
  <el-container  class="bg">
    <el-header>
      <div class="title"><!--智慧弱电远程管理系统-->
        <!-- <img v-if="languageMap['fileName']!='chinese.txt'" src="../../assets/images/english/zhdgLogo.png" style="padding-top: 25px;margin-left: 86px;"/>
        <img v-else src="../../assets/images/replaceImg/zhdgLogo.png" style="padding-top: 25px;"/> -->
      </div>
        <!-- <span style="line-height: 85px;margin-left: 20px;">版本号{{getVersion}}</span> -->
    </el-header>
    <el-container>
      <img src="../../assets/images/replaceImg/NaviBar.png" style="width: 100%; position: fixed; height: 114px;z-index: 10;">

      <el-aside :style="'height:' + (height-60) + 'px;'" width="200px" v-show="asideShow?'hidden':''">

        <img src="../../assets/images/replaceImg/menuTiao.png" style="position: absolute;top: 123px;"/>
        <div class="logo" style="margin-left: -43px;">
          <img src="../../assets/images/replaceImg/pic_logo.png" style="width: auto; height: auto;-webkit-border-radius: unset;"/>
        </div>

          <img src="../../assets/images/replaceImg/wl.png" style="margin-top: 58px;"/>

        <el-menu :default-openeds="['user', 'object']" :default-active="defaultActive" router :style='"background-color: transparent;position: absolute; top: 200px; width: 200px; overflow-y: auto;height: 800px;"'>
          <el-menu-item  index="/back/classify" >
            <i class="el-icon-menu"></i>
            <span slot="title">分类管理</span>
          </el-menu-item>
          <el-menu-item  index="/back/contactUs" >
            <i class="el-icon-phone"></i>
            <span slot="title">联系我们</span>
          </el-menu-item>
          <el-menu-item v-if="sysRole==0" index="/back/userlist" >
            <i class="el-icon-user"></i>
            <span slot="title">用户管理</span>
          </el-menu-item>
          <el-menu-item index="/back/languageConfig" >
            <i class="el-icon-s-order"></i>
            <span slot="title">语言配置</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-container style="margin-top: 19px;">
        <el-main>
          <router-view />
        </el-main>
        <!-- <el-footer>Copyright © 2019 All Rights Reserved</el-footer> -->
      </el-container>
    </el-container>
  </el-container>
</template>


<style>
.menuItemC{
    padding-left: 7px !important;
}
.tableColumnEnC .el-table__header th span{
  font-size: 12px !important;
  line-height: 13px !important;
}
.tableColumnEnC .el-table__header th div{
  font-size: 12px !important;
  line-height: 13px !important;
}
.buttonC{
    padding: 7px 0px !important;
  }
.tableCellEnC .cell{
  white-space: nowrap !important;
}
.txtOverflowShowPoint{
  white-space: nowrap !important;
  overflow: hidden;
  /* text-overflow: ellipsis; */
}

.tableColumnEnC2 .el-table__header th div{
  font-size: 12px !important;
  line-height: 13px !important;
  padding: unset !important;
}
.tableRow .el-table__row td div{
  font-size: 12px !important;
  padding: unset !important;
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
} 
.unBodyPadding .el-card__body{
  padding: unset !important;
}

</style>

<style lang="sass">
.backTabs 
  .el-icon-close::before     
    font-size: unset !important
    color: unset !important

  .el-tabs--card > .el-tabs__header
    border-bottom: 1px solid blue !important
    .el-tabs__nav
      border: 1px solid blue !important
    .el-tabs__item
      border-bottom: transparent !important
      border-left: 1px solid blue !important
      color: white
      &:first-child 
        border-left: none !important
      &:hover
        color: #409EFF
      &.is-active
        color: #409EFF    

.el-form-item__content
  line-height: 0px !important

.el-dialog__wrapper
  z-index: 201 !important

.v-modal
  z-index: 200 !important

.bg
  width: 1920px
  height: 1080px
  background: url("../../assets/images/replaceImg/sceenBg.png") center 100% no-repeat
  background-size: cover

.el-menu-item:focus, .el-menu-item:hover
  background-color: transparent !important
  background: url("../../assets/images/replaceImg/glBg2.png") left 100% no-repeat

.icon
  width: 1.5em
  height: 1.5em
  vertical-align: middle
  fill: currentColor
  overflow: hidden

.el-form-item__label
  color: #ffffff !important

.el-table
  th
    .gutter
      display: table-cell !important

.el-table
  colgroup.gutter
    display: table-cell !important

.table, .el-table, .el-table__expanded-cell
  background-color: transparent !important
  color: #ffffff !important

.el-table
  .el-table__body-wrapper::-webkit-scrollbar
    width: 6px
    height: 6px
  .el-table__body-wrapper::-webkit-scrollbar-thumb
    width: 6px
    height: 6px
    background-color: rgb(76, 152, 210)
    background-clip: padding-box
    border-radius: 5px
  .el-table__fixed-right-patch
    background-color: #1f283e !important
  .el-table--border th, .el-table__fixed-right-patch
    border-bottom: 1px solid #1f283e !important
  th
    background-color: #1177C5 !important
    color: #ffffff !important
  tr
    background-color: #092B57 !important
    color: #ffffff !important
.el-table td, .el-table th
  padding: 4px 0 !important
  border-top: 1px solid #1571C0 !important
  border-bottom: none !important

.table .el-table__expanded-cell[class*=cell]
  padding: 0 !important

.el-table--striped .el-table__body tr.el-table__row--striped
  td
    background-color: #092B57 !important
  &.current-row td
    background-color: #0051b9 !important

.el-table__body tr
  &.current-row > td
    background-color: #0051b9 !important
  &.hover-row
    &.current-row > td
      background-color: #0d518e !important
    &.el-table__row--striped
      &.current-row > td, > td
        background-color: #4c98d2 !important
    > td
      background-color: #4c98d2 !important
.table
  .el-table--enable-row-hover .el-table__body tr:hover>td
    background-color: #4c98d2 !important
  .el-table__expanded-cell
    background-color: #1d2336 !important
  .el-table__expanded-cell[class*=cell]
    padding: 0

.el-table--enable-row-hover .el-table__body tr:hover>td
    background-color: #4c98d2 !important
.el-table__expanded-cell
  background-color: #1d2336 !important

.el-table__expand-icon
  color: #ffffff !important

.el-table
  td, th.is-leaf

.el-table::before
  height: 0 !important;
.el-table__fixed-right::before, .el-table__fixed::before
  height: 0 !important;

.el-message-box
  border: none !important
  .el-message-box__content
    color: #ffffff !important
    p
      word-wrap:break-word !important
      max-height: 400px
      overflow-y: scroll
.el-dialog, .el-message-box
  background-color: #24292f !important
  color: #788193 !important
.el-dialog, .el-message-box
  .el-dialog__header,.el-message-box__header
    background-color: #062b5d !important
  .el-dialog__title,.el-message-box__title
    color: #ffffff !important
  .el-dialog__body
    background-color: #0a1e3e
  .el-dialog__footer
    background-color: #0a1e3e
    .el-button
      background: #dcdfe6 !important
    .el-button--primary
      background-color: #409EFF !important
      border-color: #409EFF !important
    .is-disabled
      color: #606266 !important
      background-color: #dcdfe6 !important
      border-color: #dcdfe6 !important

input, textarea
  color: #788193 !important

input::-webkit-outer-spin-button, input::-webkit-inner-spin-button
  -webkit-appearance: none
input[type="number"]
  -moz-appearance: textfield;

.el-input__inner, .el-textarea__inner
    border: 1px solid #007AED !important

.el-pager li
   background-color: transparent !important

.el-pagination
  color: #606266 !important
  .btn-next, .btn-prev
    color: #c1cce2 !important
    background-color: transparent !important

body
  background-color: transparent

.el-header, .el-footer
  background-color: transparent
  line-height: 60px
  color: #ffffff

.el-cascader
  margin-right: 20px



.el-header .el-dropdown
  position: fixed
  z-index: 99
  top: 0
  right: 20px
  color: #ffffff !important
  i
    color: #409eff
    span
      color: #ffffff

.tool_back
  position: fixed
  z-index: 99
  top: 0
  right: 100px

.el-header
  position: fixed
  z-index: 100
  width: 100%
  /*box-shadow: 0 0 20px 0 #121727 !important*/
  .title
    float: left
    margin-left: 200px

.el-select
  margin-right: 10px

.el-footer
  text-align: center
  line-height: 60px

.el-aside
  padding-top: 140px
  background-color: transparent
  color: #b5c2cf

.logo
  position: fixed
  width: 300px
  top: 14px
  text-align: center
  z-index: 101
  color: #788193
  img
    width: 50px
    height: 50px
    border-radius: 50%
    -webkit-border-radius: 50%
    -moz-border-radius: 50%
    box-shadow: 0px 0px 5px #121727
  span
    display: block
    padding-top: 20px

.el-menu
  background-color: transparent
  border-right: none !important

.el-submenu__title
  color: #b5c2cf !important

.el-menu-item
  height: 56px !important
  margin-top: -2px
  color: #b5c2cf !important
  background: url("../../assets/images/replaceImg/wlBg.png") left 100% no-repeat
  &.is-active
    color: #ffffff !important
    background-color: transparent
    background: url("../../assets/images/replaceImg/glBg2.png") left 100% no-repeat

.el-submenu__title:hover
  color: #ffffff !important
  background-color: transparent

.el-menu-item
  &:focus, &:hover
    color: #ffffff !important
    background-color: transparent

.el-submenu__title
  i
    color: #b5c2cf !important
  &:hover i
    color: #ffffff !important

.el-main
  min-height: 100%
  background-color: transparent
  color: #333
  padding-top: 80px !important

.card
  text-align: center
  .el-card
    background-color: transparent
    border-color: #409eff
    color: #FFFFFF
    .el-card__header
      border-bottom: 1px solid #1f283e !important
    .el-card__body
      background-color: transparent !important

.el-popper[x-placement^=bottom] .popper__arrow
  border-bottom-color: #606266 !important
  &::after
    border-bottom-color: #1f283e !important
.el-select-dropdown__empty
  background-color: #1f283e !important
.el-select-dropdown
  border: 1px solid #007AED !important
.el-select-dropdown__list
  background-color: #1f283e !important
.el-select-dropdown__item
  color: #fff !important
.el-select-dropdown__item.hover, .el-select-dropdown__item:hover
  color: #fff !important
  background-color: #4c98d2 !important
.el-select-dropdown.is-multiple .el-select-dropdown__item.selected
  background-color: #4c98d2 !important
.el-dropdown-menu
  background-color: #1f283e !important
  border: 1px solid #606266 !important
  .el-dropdown-menu__item
    color: #fff !important
  .el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover
    background-color: #4c98d2 !important
.el-picker-panel
  color: #fff !important
  background-color: #1f283e !important
  border: 1px solid #606266 !important
  .el-date-picker__header-label
    color: #fff !important
  .el-year-table td .cell
    color: #fff !important
  .el-date-range-picker__time-header
    border-bottom: 1px solid #606266
  .el-date-range-picker__content.is-left
    border-right: 1px solid #606266;
  .el-date-table td.next-month, .el-date-table td.prev-month
    color: #fff !important
  .el-month-table td .cell
    color: #fff !important
  .el-date-table th
    color: #fff !important
    border-bottom: solid 1px #606266 !important
  .el-date-table td.in-range div, .el-date-table td.in-range div:hover, .el-date-table.is-week-mode .el-date-table__row.current div, .el-date-table.is-week-mode .el-date-table__row:hover div
    background-color: #4c98d2 !important
  .el-month-table td.in-range div, .el-month-table td.in-range div:hover
    background-color: #4c98d2 !important
  .el-picker-panel__footer
    border-top: 1px solid #606266;
    background-color: #1f283e !important

.el-cascader__dropdown
  border: 1px solid #606266 !important
.el-cascader-panel
  color: #fff !important
  background-color: #1f283e !important
  .el-cascader-menu
    color: #fff !important
    border-right: solid 1px #606266;
  .el-cascader-node:not(.is-disabled):focus, .el-cascader-node:not(.is-disabled):hover
    color: #fff !important
    background-color: #4c98d2 !important
.el-picker-panel .el-date-table td.next-month, .el-picker-panel .el-date-table td.prev-month
  color: #606266 !important
.el-input__inner
  color: #fff !important
  background-color: #1f283e !important
.el-date-editor .el-range-input
  color: #fff !important
  background-color: #1f283e !important
.el-date-range-picker__time-header>.el-icon-arrow-right
  color: #fff !important
.el-date-editor .el-range-separator
  color: #fff !important
.el-picker-panel__icon-btn
  color: #fff !important
.el-time-panel
  background-color: #1f283e !important
  border: 1px solid #4a98db !important
.el-time-panel__footer
  border: 1px solid #4a98db !important

.el-time-spinner__item.active:not(.disabled)
  color: #fff !important
.el-time-panel__btn
  color: #fff !important
.el-pagination__total
  color: #c1cce2 !important
.el-pager .number
  color: #c1cce2
.el-pagination .btn-prev:disabled
  color: #606266 !important
.el-pagination .btn-next:disabled
  color: #606266 !important
.btnSmallStyle
  display: inline-block
  cursor: pointer
  text-align: center
  background: url("../../assets/images/replaceImg/btn_2a_normal.png") center 100% no-repeat
  &:hover
    background: url("../../assets/images/replaceImg/btn_2a_highlight.png") center 100% no-repeat
.btnSmallStyle:active
  background: url("../../assets/images/replaceImg/btn_2a_disable.png") center 100% no-repeat
.btnSmallStyle[disabled]
    pointer-events: none
    background: url("../../assets/images/replaceImg/btn_2a_disable.png") center 100% no-repeat

.btnBigStyle
  display: inline-block
  cursor: pointer
  text-align: center
  background: url("../../assets/images/replaceImg/btn_6a_normal.png") center 100% no-repeat
  &:hover
    background: url("../../assets/images/replaceImg/btn_6a_highlight.png") center 100% no-repeat
.btnBigStyle:active
  background: url("../../assets/images/replaceImg/btn_6a_disable.png") center 100% no-repeat
.btnBigStyle[disabled]
    pointer-events: none
    background: url("../../assets/images/replaceImg/btn_6a_disable.png") center 100% no-repeat

.btnBigStyle2
  display: inline-block
  cursor: pointer
  text-align: center
  background: url("../../assets/images/replaceImg/btn_7a_normal.png") center 100% no-repeat
  &:hover
    background: url("../../assets/images/replaceImg/btn_7a_highlight.png") center 100% no-repeat
.btnBigStyle2:active
  background: url("../../assets/images/replaceImg/btn_7a_disable.png") center 100% no-repeat
.btnBigStyle2[disabled]
  pointer-events: none
  background: url("../../assets/images/replaceImg/btn_7a_disable.png") center 100% no-repeat

.btnBigStyle3
  display: inline-block
  cursor: pointer
  text-align: center
  background: url("../../assets/images/replaceImg/btn_8a_normal.png") center 100% no-repeat
  &:hover
    background: url("../../assets/images/replaceImg/btn_8a_highlight.png") center 100% no-repeat
.btnBigStyle3:active
  background: url("../../assets/images/replaceImg/btn_8a_disable.png") center 100% no-repeat
.btnBigStyle3[disabled]
  pointer-events: none
  background: url("../../assets/images/replaceImg/btn_8a_disable.png") center 100% no-repeat

.menuBut2
    width: 255px !important
    margin-right: 15px !important
    margin-left: 5px !important
    font-size: 18px !important
    padding-top: 5px !important
    text-align: center
    background: url('../../assets/images/replaceImg/tab_lb2.png') center 100% no-repeat
    &:hover
     background: url("../../assets/images/replaceImg/tab_lb_pre2.png") center 100% no-repeat
    &.is-active
     border-bottom: none !important
     background: url("../../assets/images/replaceImg/tab_lb_pre2.png") center 100% no-repeat 

.el-icon-close::before     
  font-size: 30px
  color: white

.el-dialog__close
  line-height: 0 !important

.el-message-box
  background-color: #0a1e3e !important

.el-icon-close::before
  line-height: 0.5 !important

.playBodyEnC .el-card__body
  padding: 5px !important

.el-table__row
  line-height: 23px !important

.el-transfer-panel .el-transfer-panel__header
  border-bottom: 1px solid #007AED !important
  background-color: #24292f !important
  
.el-transfer-panel
  border: 1px solid #007AED !important
  
.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label
  color: white !important  
  span
    color: white !important
.el-transfer-panel__body
  background-color: #24292f !important;

.el-transfer-panel__item.el-checkbox .el-checkbox__label
  color: white !important

.sxzC .el-transfer-panel
  width: 237px
  border: 1px solid #007AED !important  

.sxzC2 .el-transfer-panel
  width: 307px
  border: 1px solid #007AED !important    
</style>


<script>
import store from "./../../store";
import config from "./../../config";

export default {
  data() {
    return {
      width: window.innerWidth,
      height: window.innerHeight,
      asideShow: true,
      defaultActive: this.$route.fullPath,
      sysRole: store.state.sysRole,
      userName: "",
      layoutTimer: null,
      updateMenu:null,
      languageMap:{}
    };
  },
  computed: {
    getTitle() {
      return store.state.config.title || '北京明瑞之光';
    }
  },
  mounted() {

    this.height = window.innerHeight;
    window.onresize = () => {
      this.height = window.innerHeight;
    };

    this.userName = sessionStorage.getItem("userName");
    this.sysRole = sessionStorage.getItem("sysRole");
    let _this=this;
    this.layoutTimer=setInterval(function(){
      _this.userName = sessionStorage.getItem("userName");
      _this.sysRole = sessionStorage.getItem("sysRole");
    }, 1000);

   this.updateMenu= setInterval(function(){
      if(_this.$route.fullPath.indexOf("?")!=-1){ 
       _this.defaultActive=_this.$route.fullPath.substring(0,_this.$route.fullPath.indexOf("?"));
      //  console.log(_this.defaultActive+"--------------")
     }else{
       _this.defaultActive=_this.$route.fullPath;
     }
      // console.log(_this.defaultActive)
    },200);
    
    if(!sessionStorage.getItem("userName")){
      // this.getCurrentLoginUser();
    }

    if (window.innerWidth < 500) {
      this.asideShow = false;
    }

    window.onresize = () => {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      if (this.width <= 500) {
        this.asideShow = false;
      } else {
        this.asideShow = true;
      }
    };
  },
  beforeDestroy() {
    window.clearInterval(this.layoutTimer);
    window.clearInterval(this.updateMenu);
  },
  methods: {
    getCurrentLoginUser() {
      let url = config.url + "SysUserController/getCurrentLoginUser.action";
      let param = {}
      this.$http.post(url, param).then(res => {
        let data = res.data;
        if(data.resultCode == 200){
          sessionStorage.setItem("userName", data.data.userName);
          sessionStorage.setItem("sysRole", data.data.sysRole);
          this.userName = data.data.userName;
          this.sysRole = data.data.sysRole;
        }
      })
    },
    outLogin() {
      store.state.token = "";
      store.state.optionsProject = [];
      store.state.optionsGroup = [];
      store.state.valueProject = "";
      store.state.valueGroup = "";
      store.state.nodeInfoOnlineNum = {};
      sessionStorage.removeItem("userName");
      this.$router.push({ path: "/backLogin" });
    },
 getCookie(name) {  //this.languageMap['获取cookie']
  var arr = null;
  var reg = new RegExp("(^| )"+name+"=([^;]*)(;|$)");
  var arr=document.cookie.match(reg);
  if(arr) {
     return unescape(arr[2]);
  } else {
     return null;
  }
 }
  },
  components: {
    
  }
};
</script>
